import { useEffect } from "react";

export const SITE_URL = "https://oxyvin.com";
export const OG_IMAGE = "https://customer-assets-v7afamib.emergentagent.net/wingman/ee856bdb-af6c-45a4-82b9-d4c47aec411b/attachments/8b39a18ce1b84e07a64a2c05f30e2f69_oxyvin%20hero%20image%20gpt.png";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, path = "/", type = "website", jsonLd, noindex = false }) {
  const ld = JSON.stringify(jsonLd || null);
  useEffect(() => {
    const fullTitle = title.includes("Oxyvin") ? title : `${title} | Oxyvin`;
    document.title = fullTitle;
    const url = SITE_URL + path;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", OG_IMAGE);
    setMeta("property", "og:site_name", "Oxyvin");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", OG_IMAGE);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = url;
    let script;
    if (ld !== "null") {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.routeSeo = "1";
      script.text = ld;
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
  }, [title, description, path, type, ld, noindex]);
}

export const seoMap = {
  "/": { title: "Oxyvin — Flexible Customer Engagement, Powered by People and Technology", description: "Distributed workforce. Centralized control. Scale multilingual customer engagement capacity up or down without building permanent internal teams." },
  "/services": { title: "Customer Engagement Services", description: "Outbound, inbound, overflow, flexible and multilingual customer engagement services that flex with your demand." },
  "/industries": { title: "Industries", description: "Flexible customer engagement for education, BFSI, SaaS & technology and other demand-driven industries." },
  "/engagement-maturity": { title: "The Oxyvin Engagement Maturity Model", description: "Five levels — Reactive, Managed, Connected, Intelligent, Adaptive — across people, process, technology, transparency, intelligence and flexibility." },
  "/resources": { title: "Resources — Case Studies & Insights", description: "Case studies, guides and practical thinking on flexible, multilingual customer engagement from the Oxyvin team." },
  "/contact": { title: "Talk to Oxyvin", description: "Tell us what you're trying to achieve. We'll help you determine the right customer engagement model." },
  "/privacy": { title: "Privacy Policy", description: "How Oxyvin handles information submitted through this website." },
  "/terms": { title: "Terms of Use", description: "Terms governing the use of the Oxyvin website." },
};
